const { getNumber, trackGtm, trackGtm4 } = require('../../../../js/functions');
const {
	stuttering,
	default: onWidthResize,
} = require('../../../../js/onWidthResize');
const {
	outClickSubscribe,
	outClickUnSubscribe,
} = require('util/outClickSubscriber');
/* eslint-disable */
const {
	ingredientsMenuMargin,
} = require('!!sass-variable-loader!./_style.scss');
/* eslint-enable */

const padding = getNumber(ingredientsMenuMargin);

const ingredientsTemplate = require('./ingredients.hbs');
const dropdownTemplate = require('./dropdown.hbs');

const CLASS_OPEN = 'open';
const CLASS_ACTIVE = 'active';

module.exports = {
	init() {
		this.initValues();
		this.initElements();

		if (!this.preSelected) this.initMenu();
		else this.setContent(this.preSelected);
		onWidthResize(this.onResize.bind(this), stuttering.DEBOUNCE, 100);
	},
	initValues() {
		this.preSelected = this.root.dataset.selected;
		this.apiData = this.root.dataset.apiData;
		this.apiList = this.root.dataset.apiList;
		this.addedIngredientsTitle = this.root.dataset.addedIngredientsTitle;
		this.specificBrandsTitle = this.root.dataset.specificBrandsTitle;
		this.isRRP = this.root.dataset.rrp === 'true';
		this.openedMenu = false;
	},
	initElements() {
		this.menu = this.root.querySelector('.ingredient-finder--menu');
		this.menuButton = this.root.querySelector(
			'.ingredient-finder--drop-button',
		);
		this.drop = this.root.querySelector('.ingredient-finder--dropdown');
		this.ingredients = this.root.querySelector(
			'.ingredient-finder--ingredients',
		);
		this.container = this.root.querySelector('.ingredient-finder--container');
	},
	async initMenu() {
		const response = await fetch(this.apiList);
		if (response.ok) {
			const list = await response.json();
			list.sort((a, b) => a.title.localeCompare(b.title));
			this.drop.innerHTML = dropdownTemplate({ list });
			this.dropList = this.root.querySelector('.ingredient-finder--list');
			this.menuButton.addEventListener('click', this.toggleMenu.bind(this));
			this.drop.addEventListener('click', this.dropClick.bind(this));
			this.menu.classList.add(CLASS_ACTIVE);
		}
	},
	toggleMenu() {
		if (this.openedMenu) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	},
	openMenu() {
		if (!this.openedMenu)
			outClickSubscribe(this.menu, this.closeMenu.bind(this));
		const contentHeight = this.dropList.offsetHeight + padding * 2;
		// if list is too long the cropping is of 60% of windows height but minimum 200px
		const height = Math.min(
			Math.max(200, window.innerHeight * 0.6),
			contentHeight,
		);
		this.menu.classList.add(CLASS_OPEN);
		this.drop.style.height = height + 'px';
		this.openedMenu = true;
	},
	closeMenu() {
		if (this.openedMenu) {
			this.menu.classList.remove(CLASS_OPEN);
			this.drop.style.height = 0;
			outClickUnSubscribe(this.menu);
			this.openedMenu = false;
		}
	},
	onResize() {
		const height = this.ingredients.offsetHeight;
		if (height) this.container.style.height = height + 'px';
		this.closeMenu();
	},
	async setContent(id, title) {
		const response = await fetch(this.apiData + '/' + id);
		if (response.ok) {
			const data = await response.json();
			const content = data[this.isRRP ? 'RRP' : 'Combustible'];
			this.ingredients.innerHTML = ingredientsTemplate({
				addedIngredients: {
					title: this.addedIngredientsTitle,
					list: content.addedIngredients,
				},
				specificBrands: {
					title: this.specificBrandsTitle,
					list: content.specificBrands,
				},
			});
			if (this.menuButton) {
				this.menuButton.innerText = title;
				this.menu.classList.add(CLASS_ACTIVE);
			}
			this.container.style.height = this.ingredients.offsetHeight + 'px';
		}
	},
	dropClick({ target }) {
		const id = target.dataset.id;
		const title = target.innerText;
		if (id) {
			this.closeMenu();
			this.menu.classList.remove(CLASS_ACTIVE);
			trackGtm({
				eventCategory: 'ingredient finder',
				eventAction: 'click',
				eventLabel: title,
			});
			trackGtm4({
				event: 'GA4_event_c_ingredient_finder',
				widget_name: 'V3-Product-ingredient-finder',
				location: title ? title.trim() : 'No title',
			});
			this.setContent(id, title);
		}
	},
};
